import { useRef, useEffect, memo, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import SoftButton from "components/SoftButton";
import { closeNewIntegrationDialog } from "redux/actions/portal/integrationActionCreator";
import { useAuth0 } from "@auth0/auth0-react";
import "./styles.css";
import { FormStep } from "./Steps/Form";
import SoftBox from "components/SoftBox";
import {
	createNewIntegration,
	setIntegrationMutatingFlag
} from "redux/actions/portal/integrationActionCreator";
import { uploadFile } from "helpers/common";
import { toast } from "react-toastify";

export const NewIntegrationDialog = memo(() => {
	const { user } = useAuth0();
	const { t } = useTranslation("flowDesigner");
	const { showNewIntegrationDialog, integrationMutatingFlag } = useSelector(
		(store) => store?.portal?.integrations
	);
	const dispatch = useDispatch();
	const formRef = useRef(null);
	const [pictureUpload, setPictureUpload] = useState(null);

	const handleFormStepSubmit = async (values) => {
		if (!user?.stripeId || !user?.cxfUserId) return;

		const newIntegration = {
			tenant_id: user.stripeId,
			create_user_id: user.cxfUserId,
			modified_user_id: user.cxfUserId,
			flows: [],
			...values
		};

		try {
			if (pictureUpload) {
				const result = await uploadFile(
					user,
					pictureUpload,
					"integrations",
					values.integrationName,
					true
				);
				newIntegration.logo = result?.Location;
			}

			dispatch(setIntegrationMutatingFlag(true));
			dispatch(createNewIntegration(newIntegration));
		} catch (error) {
			console.error(error);
			toast.error("Failed to save the integration");
		}
	};

	const resetNewIntegration = () => {
		dispatch(closeNewIntegrationDialog());
		setPictureUpload(null);
	};

	useEffect(() => {
		if (!showNewIntegrationDialog) {
			setTimeout(() => resetNewIntegration(), 1000);
		}
	}, [showNewIntegrationDialog]);

	return (
		<Dialog
			className="integration-dialog"
			open={showNewIntegrationDialog}
			onClose={resetNewIntegration}
			fullWidth={true}
			maxWidth="csm"
		>
			<DialogTitle
				data-testid="form-title"
				sx={{
					marginBottom: "20px",
					padding: "32px 0 0 48px"
				}}
				className="white-to-dark"
			>
				New Integration
			</DialogTitle>
			<DialogContent
				sx={{
					padding: "0 48px 24px"
				}}
			>
				<SoftBox>
					<FormStep
						ref={formRef}
						handleFormStepSubmit={handleFormStepSubmit}
						pictureUpload={pictureUpload}
						setPictureUpload={setPictureUpload}
					/>
				</SoftBox>
			</DialogContent>
			<DialogActions>
				<SoftButton
					disabled={!!integrationMutatingFlag}
					variant="outlined"
					color="info"
					onClick={resetNewIntegration}
				>
					{t("buttons.cancel")}
				</SoftButton>

				<SoftButton
					disabled={!!integrationMutatingFlag}
					color="primary"
					onClick={() => formRef.current?.submitForm()}
				>
					{t("buttons.create")}
				</SoftButton>
			</DialogActions>
		</Dialog>
	);
});
